import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

import { type QuestionnaireDto, questionnaireDtoSchema } from '../schemas/questionnaireSchemas';
import { questionnaireKeys } from './questionnaireKeys';

export type QuestionnaireStatus = 'Draft' | 'Active' | 'Archived';

interface Vars {
  questionnaireId: string;
  status: QuestionnaireStatus;
}

export function useChangeQuestionnaireStatus() {
  const qc = useQueryClient();
  const tenantId = useTenantStore((s) => s.tenantId);

  return useMutation({
    mutationFn: async ({ questionnaireId, status }: Vars): Promise<QuestionnaireDto> => {
      const raw = await apiClient
        .post(`api/v1/t/${tenantId}/questionnaires/${questionnaireId}/status`, {
          json: { status },
        })
        .json();
      return questionnaireDtoSchema.parse(raw);
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: questionnaireKeys.lists() });
    },
  });
}
